import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import CheckBoxOutlineBlankRoundedIcon from "@mui/icons-material/CheckBoxOutlineBlankRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";

export const ADDRESS_FIELD_TYPE_OPTIONS = [
  { value:"REQUIRED", label:"Obligatorisk", messageId:"addresses.required", icon:CheckCircleOutlineRoundedIcon },
  { value:"OPTIONAL", label:"Frivillig", messageId:"addresses.optional", icon:CheckBoxOutlineBlankRoundedIcon },
  { value:"FIXED", label:"Fast", messageId:"addresses.fixed", icon:LockOutlinedIcon },
  { value:"HIDDEN", label:"Dold", messageId:"addresses.hidden", icon:VisibilityOffOutlinedIcon }  
];

export const getAddressFieldTypeOption = value =>
  ADDRESS_FIELD_TYPE_OPTIONS.find(option => option.value === value) || ADDRESS_FIELD_TYPE_OPTIONS[1];
